<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.oa_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="oa_emname">
            <label class="weui-form-preview__label">{{customLabel.oa_emname || "申请人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.oa_emname}}
              <call-mobile :em-id="form.main.oa_emid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="oa_department">
            <label class="weui-form-preview__label">{{customLabel.oa_department || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.oa_department}}</span>
          </div>
          <div class="weui-form-preview__item" slot="oa_address">
            <label class="weui-form-preview__label">{{customLabel.oa_address || "外出地点"}}</label>
            <span class="weui-form-preview__value">{{form.main.oa_address}}</span>
          </div>
           <div class="weui-form-preview__item" slot="oa_outtype">
            <label class="weui-form-preview__label">{{customLabel.oa_outtype || "外出类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.oa_outtype}}</span>
          </div>
          <div class="weui-form-preview__item" slot="oa_startime">
            <label class="weui-form-preview__label">{{customLabel.oa_startime || "开始时间"}}</label>
            <span class="weui-form-preview__value">{{form.main.oa_startime}}</span>
          </div>
          <div class="weui-form-preview__item" slot="oa_endtime">
            <label class="weui-form-preview__label">{{customLabel.oa_endtime || "结束时间"}}</label>
            <span class="weui-form-preview__value">{{form.main.oa_endtime}}</span>
          </div>
          <div class="weui-form-preview__item" slot="oa_alltimes">
            <label class="weui-form-preview__label">{{customLabel.oa_alltimes || "外出时长"}}</label>
            <span class="weui-form-preview__value">{{form.main.oa_alltimes}}h</span>
          </div>
          <div class="weui-form-preview__item" slot="oa_remark">
            <label class="weui-form-preview__label">{{customLabel.oa_remark || "外出事由"}}</label>
            <span class="weui-form-preview__value">{{form.main.oa_remark}}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.oa_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/travel_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/oa/outapply",
      codeField: "oa_code",
      statusField: "oa_statuscode",
      caller: "OutApply",
      xtype: "oa-outapply-formpanel",
    };
  }
};
</script>